import React from "react";
import styled from "styled-components";
import { PropTypes } from "prop-types";
import Marquee from "react-fast-marquee";

const CardContainerGrid = styled.div.attrs(({ $columns }) => ({
  $columns: $columns,
}))`
  display: grid;
  grid-template-columns: ${({ $columns }) => `repeat(${$columns}, 1fr)`};
  width: 100%;
  justify-items: center;
  gap: 1rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    justify-content: start;
    display: flex;
    flex-flow: row wrap;
  }
`;

const CardContainerAutoplay = styled(Marquee)`
  display: flex;
  grid-template-columns: ${({ $columns }) => `repeat(${$columns}, 1fr)`};
  width: 100%;
  align-items: flex-start;
  justify-items: flex-start;
  gap: 1rem;
  > div {
    align-items: flex-start;
    justify-items: flex-start;
    gap: 1rem;
  }
  .rfm-marquee,
  .rfm-initial-child-container {
    gap: 1rem;
    align-items: stretch;
    justify-items: flex-start;
    padding-bottom: 1rem;
  }
  .rfm-child {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    max-width: 300px;
  }
  .rfm-child > div a:first-child {
    height: 200px;
  }
  .rfm-child > div > *:not(:first-child) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.wideTablet}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    justify-content: start;
    display: flex;
    flex-flow: row wrap;
    .rfm-child > div {
      margin: 0;
      padding: 0;
      max-width: 200px;
    }
    .rfm-child > div a:first-child {
      height: 150px;
    }
  }
`;

const CardContainerList = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column wrap;
  gap: 2rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    gap: 1rem;
  }
`;

const CardContainer = ({
  autoplay,
  columns,
  postLayout,
  children,
  className,
}) => {
  return (
    <>
      {postLayout === "grid" ? (
        <>
          {autoplay === "disabled" ? (
            <CardContainerGrid $columns={columns} className={className}>
              {children}
            </CardContainerGrid>
          ) : (
            <CardContainerAutoplay
              $columns={columns}
              className={className}
              speed={15}
              direction={"left"}
              autoFill
              pauseOnHover={"true"}
            >
              {children}
            </CardContainerAutoplay>
          )}{" "}
        </>
      ) : (
        <CardContainerList className={className}>{children}</CardContainerList>
      )}
    </>
  );
};

CardContainer.propTypes = {
  autoplay: PropTypes.string,
  children: PropTypes.node,
  columns: PropTypes.number,
  postLayout: PropTypes.string,
  className: PropTypes.string,
};

export default CardContainer;
